import React, { useEffect, useRef } from "react";

export default function Adsense() {
  const adRef = useRef(null);

  useEffect(() => {
    try {
      if (window.adsbygoogle && adRef.current) {
        window.adsbygoogle.push({});
      }
    } catch (e) {}
  }, []);

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        margin: "0 auto",
        padding: 0,
        boxSizing: "border-box",
      }}
    >
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{
          display: "block",
          width: "100%",
          maxWidth: "100%",
          minHeight: "90px",
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
        }}
        data-ad-client="ca-pub-4942463590341754"
        data-ad-slot="4116738356"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}